import React, { useEffect, useState } from "react";
import Axios from "axios";
import ReactGA from 'react-ga4';
import { BASE_URL } from "../api";
import { useLocation } from "react-router-dom";
import "./EasebuzzPayment.css";
import { useNavigate } from "react-router-dom";

function RedirectPaymentPage() {
  //Request Amount Api
  const [requestamount, setRequestAmount] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${BASE_URL}core/requested_amount/`)
      .then((response) => response.json())
      .then((data) => setRequestAmount(data.data))
      .catch((error) => console.error(error));
  }, []);
  // console.log(requestamount);
  // Geting player information from the server response
  const location = useLocation();
  const responseData = location.state;
  // console.log("EaseBuzz Page", responseData);
  const student_id = responseData.id;
  const amount = requestamount.amount;
  const productinfo = "ISBC";
  const firstname = responseData.full_name;
  const email = responseData.email;
  const phone = responseData.mobile;
  var token = localStorage.getItem("token");

  const initiatePayment = async () => {
    ReactGA.event({
      category: 'Pay Now Button',
      action: 'Button Click',
      label: 'Pay Now Button'
    });
    try {
      // Define the request data
      const requestData = {
        student_id: student_id,
        amount: amount,
        productinfo: productinfo,
        firstname: firstname,
        email: email,
        phone: phone,
      };

      // console.log("Requested Data", JSON.stringify(requestData));

      // Set the request headers
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Token ${token}`,
      };

      // Make the POST request
      const response = await Axios.post(
        `${BASE_URL}payments/v1/initiate_payment/`,
        requestData,
        { headers }
      );

      // Handle the response
      // console.log("EaseBuzz Payment Response:", response.data.data);
      // console.log(
      //   "EaseBuzz Payment Response WebView:",
      //   response.data.data.easebuzz.data
      // );
      // const dataView = response.data.data.easebuzz.data;
      // const url =`https://pay.easebuzz.in/pay/${dataView}`
      // const url = `https://testpay.easebuzz.in/pay/${dataView}`;

      // window.location.href = url;
      if (response.data.status === true) {
        if (response.data.code === 3) {
          // Navigate to Student List page
          navigate("/registered-players");
          // console.log("Transation Updated");
        } else {
          const dataView = response.data.data.easebuzz.data;
          const url = `https://pay.easebuzz.in/pay/${dataView}`;

          window.location.href = url;
          // console.log("New Transaction Created");
        }
      } else if (response.data.status === false) {
        // Show the error message
        setShowErrorMessage(true);
        //  setTimeout(() => {
        //  setShowErrorMessage(false);
        //  },); // Hide the message after 5 seconds
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="container-payment">
      <div className="rzp-container-2">
        <div className="PaymentText-rzp">
          <h5>
            Please proceed to make a payment of "Rs:{requestamount.amount}" to
            complete your enrollment.
          </h5>
        </div>
        <div className="rzp-btn-payNow">
          <button
            onClick={initiatePayment}
            className="profile-preview-payment-btn"
          >
            Pay Now
          </button>
        </div>
      </div>
      {/* Custom error message */}
      {showErrorMessage && (
        <div className="error-message">
          <i class="fa-regular fa-circle-xmark"></i>
          <h1>Something went wrong. Please try again later.</h1>
        </div>
      )}
    </div>
  );
}

export default RedirectPaymentPage;
